import { getTopPageUrl } from "./top-page.js";
import { findCleonContainers } from "../core/container-dom.js";
import { initCleonContainer } from "../core/container-init.js";
import { getSafeSiteUrl } from "./top-page.js";

export function setupConsentBridge() {
    window.addEventListener("cleon:consent-granted", () => {

        findCleonContainers().forEach((container) => {
          if (
            container.__cleonQueued ||
            container.__cleonInitialized ||
            container.__cleonInitializing
          ) {
            return;
          }

          if (container.firstChild) {
            container.innerHTML = "";
          }

          container.hidden = false;

          void initCleonContainer(container);
        });
    });

}

export function listenToTCFChanges() {
    if (typeof window.__tcfapi !== "function") return;

    window.__tcfapi("addEventListener", 2, (tcData, success) => {
        if (!success || !tcData) return;

        if (tcData.eventStatus === "useractioncomplete") {
            const p = tcData.purpose?.consents || {};
            const allowed = p["2"] === true;

            if (allowed) {
                window.dispatchEvent(new CustomEvent("cleon:consent-granted"));
            } else {
                window.dispatchEvent(new CustomEvent("cleon:consent-denied"));
            }
        }
    });
}

export function addConsentToZoneUrl(url, consent = {}) {
  const u = new URL(url, window.location.href);

  const gpp = consent?.gppString || null;
  const gppSid = consent?.gppSid || null;
  const gdprConsent = consent?.tcString || null;
  const usPrivacy = consent?.uspString || null;

  const gdpr =
    consent?.gdprApplies === true
      ? "1"
      : consent?.gdprApplies === false
        ? "0"
        : "";

  if (gdpr !== "") {
    u.searchParams.set("gdpr", gdpr);
  }

  if (!gpp && !gppSid && !gdprConsent && !usPrivacy) {
    return replaceKnownAdMacros(u.toString());
  }

  if (gdprConsent) {
    u.searchParams.set("gdpr_consent", gdprConsent);
  }

  if (gpp) {
    u.searchParams.set("gpp", gpp);
  }

  if (gppSid) {
    u.searchParams.set("gpp_sid", gppSid);
  }

  if (usPrivacy) {
    u.searchParams.set("us_privacy", usPrivacy);
  }

  const siteUrl = getSafeSiteUrl(
    getTopPageUrl() || document.referrer || window.location.href
  );

  if (siteUrl) {
    u.searchParams.set("siteurl", siteUrl);
  }
  
  return replaceKnownAdMacros(u.toString());
}

export function replaceKnownAdMacros(url) {
  return url
    .replaceAll("{maxduration_ms}", "30000")
    .replaceAll("%7Bmaxduration_ms%7D", "30000")
    .replaceAll("{sd_max}", "60000")
    .replaceAll("%7Bsd_max%7D", "60000");
}
    // .replaceAll("{pmaxd}", "30")
    // .replaceAll("%7Bpmaxd%7D", "30");